import * as actionTypes from '../constants/action.types'
import actionCreator from '../utils/actions/creator'

export const prepareWebAuthnRegistration = actionCreator(
  actionTypes.PREPARE_WEB_AUTHN_REGISTRATION
)

export const prepareWebAuthnRegistrationFailed = actionCreator(
  actionTypes.PREPARE_WEB_AUTHN_REGISTRATION_FAILED
)

export const registerWebAuthn = actionCreator(
  actionTypes.REGISTER_WEB_AUTHN,
  ({ registrationData } = {}) => ({
    registrationData
  })
)

export const registerWebAuthnSucceeded = actionCreator(
  actionTypes.REGISTER_WEB_AUTHN_SUCCEEDED
)

export const registerWebAuthnFailed = actionCreator(
  actionTypes.REGISTER_WEB_AUTHN_FAILED
)

export const finishWebAuthnRegistration = actionCreator(
  actionTypes.FINISH_WEB_AUTHN_REGISTRATION,
  credential => credential
)

export const finishWebAuthnRegistrationSucceeded = actionCreator(
  actionTypes.FINISH_WEB_AUTHN_REGISTRATION_SUCCEEDED
)

export const finishWebAuthnRegistrationFailed = actionCreator(
  actionTypes.FINISH_WEB_AUTHN_REGISTRATION_FAILED
)
